import React, { useState, useEffect } from 'react';
import { logger } from '../utils/logger';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { Loader2 } from 'lucide-react';
import { getFAQs } from '../services/api';

export const FAQSection = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    const fetchFAQs = async () => {
      try {
        setLoading(true);
        const data = await getFAQs();
        setFaqs(data);
        setError(null);
      } catch (err) {
        logger.error('Failed to fetch FAQs:', err);
        setError('Kon FAQ\'s niet laden');
      } finally {
        setLoading(false);
      }
    };
    
    fetchFAQs();
  }, []);
  
  return (
    <section className="py-20 bg-gradient-to-br from-white via-white to-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-sweet-sans text-3xl sm:text-4xl font-normal text-earth-brown mb-6 uppercase tracking-wide">
              Veelgestelde vragen
            </h2>
            <p className="font-sweet-sans text-sm text-almost-black/80">
              Alles wat u moet weten over onze handgemaakte manden
            </p>
          </div>
          
          {loading ? (
            <div className="flex items-center justify-center py-12">
              <Loader2 className="w-8 h-8 text-terra-beige animate-spin" />
            </div>
          ) : error ? (
            <div className="text-center py-12 text-red-600">{error}</div>
          ) : (
            <Accordion type="single" collapsible className="space-y-4">
              {faqs.map((faq) => (
                <AccordionItem 
                  key={faq.id} 
                  value={`item-${faq.id}`}
                  className="border border-terra-beige/20  px-6 bg-white/30 hover:bg-white/60 transition-colors duration-200"
                >
                  <AccordionTrigger className="font-sweet-sans text-almost-black hover:text-terra-beige hover:no-underline py-5 uppercase tracking-wide">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="font-sweet-sans text-sm text-almost-black/80 leading-relaxed pb-5">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          )}
        </div>
      </div>
    </section>
  );
};